import React from "react";
import { CircleWithBadge } from "../../../advancing/components/circlewithbadge";

interface Props {
  filesCount: number
}

const FilesBadge = (props: Props) => {
  const { filesCount } = props;
  const title = (filesCount === 1) ? `1 ${RESX.File.resxFile}` : `${filesCount} ${RESX.File.Files}`;
  return <CircleWithBadge icon="paperclip" count={filesCount} title={title} />;
};

export default FilesBadge;